import React, { useEffect, useState } from 'react';
import { usePagination } from '@arema/components/Hooks';
import { useTranslation } from 'react-i18next';
import { Button, Groupper, Header, Image, Pagination, SegmentControl } from 'react-frontier2';
import { Link } from 'react-router-dom';
import { CDN_URL, PLACEHOLDER_IMG } from '../../AdminConfig';
import { CatalogEvent } from '@arema/components/Classes';
import { fromUnix, fromUnixLocal } from '@arema/components/Util';
import API from '../../API';

const PAGE_SIZE = 20;

interface EventCreationData{
	dates: number,
	first_date: number,
	date_created: number,
}
var EventItem = (props: { event: CatalogEvent, creation?: EventCreationData })=>{
	var { t } = useTranslation();
	return <Link className="ar event-item item" to={`/events/${props.event.event_id}`}>
		<Image src={`${CDN_URL}/events/${props.event.event_id}/200.webp`} alt={props.event.event_name} fallback={PLACEHOLDER_IMG} />
		<div className="left">
			<div className="meta" style={{ fontSize: 12, lineHeight: '14px' }}>Evento #{props.event.event_id}</div>
			<div className="name">{props.event.event_name}</div>
			{props.creation ? <>
				<div className="date" style={{ fontSize: 12, lineHeight: '14px' }}>{fromUnix(props.creation.first_date).toFormat('dd/MMM/yy')}</div>
				<div className="meta" style={{ fontSize: 12, lineHeight: '14px' }}>{t('event_list.created')}: {fromUnixLocal(props.creation.date_created).toFormat('dd/MMM/yy HH:mm')}</div>
				<div className="meta" style={{ fontSize: 12, lineHeight: '14px' }}>{t('event_list.dates')}: {props.creation.dates}</div>
			</> : !!props.event.date && <>
				<div className="date" style={{ fontSize: 12, lineHeight: '14px' }}>{fromUnix(props.event.date).toFormat('dd/MMM/yy')}</div>
				<div className="city" style={{ fontSize: 12, lineHeight: '14px' }}>{props.event.city}</div>
			</>}
		</div>
	</Link>
}

var EventList = ()=>{
	var { t } = useTranslation();
	var [searchQuery, setSearchQuery] = useState<string>(null);
	var { page, setPage, fetch, onParamsChange, params, data, loadError, loading } = usePagination<{
		popular: boolean,
		search: boolean,
		query: string
	}, CatalogEvent[]>({
		defaultParams: {
			popular: true,
			search: false,
			query: '',
		},
		fetch: (page, data)=>{
			if(data?.popular){
				return API.getPopularEvents(0, PAGE_SIZE);
			}else if(data.search){
				return API.searchEvent(data?.query, page*PAGE_SIZE, PAGE_SIZE);
			}else{
				return API.listEvents(page*PAGE_SIZE, PAGE_SIZE);
			}
		},
		onParamsChange: (params)=>{
			if(params.search && (!params.query || params.query.length==0)){
				setSearchQuery(null);
				fetch({
					popular: true,
					search: false,
					query: ''
				});
			}
		}
	});

	var searchEvents = ()=>{
		setSearchQuery(params.query);
		fetch({
			popular: false,
			search: true,
			query: params.query,
		});
	}

	return <div>
		<Groupper fitted 
			style={{ maxWidth: 600 }}
			title={t('common.events')} 
			titleRight={(
				<Button text={t('event_list.create_event')} color='black' as={Link} to={'/events/create'} iconName='plus-circle' />
			)}
			actions={(!params.popular && data && (data.length>=PAGE_SIZE || page>0)) ? (
				<Pagination page={page} onPageChange={setPage} hasNext={data.length>=PAGE_SIZE} />
			) : null}
		>
			<Groupper.DividerInput removeMargin={['top']} removeBorder={['top']} value={params?.query || ''} onChange={onParamsChange('query')} inputStyle={{ paddingLeft: 15, paddingRight: 15 }} placeholder={t('event_list.search_events')} onSubmit={searchEvents} />
			{!params.search ? (
				<SegmentControl
					style={{ margin: 10, width: 'auto' }}
					segments={[
						{ text: t('event_list.popular'), value: 0 },
						{ text: t('event_list.creation_list'), value: 1 },
					]}
					selected={params?.popular===true ? 0 : 1}
					onClick={v=>{
						if(params?.popular!==(v===0)){
							fetch({
								popular: v===0,
								search: false,
								query: ''
							});
						}
					}}
				/>
			) : (
				<div style={{ height: 50, padding: 10, margin: 10, backgroundColor: 'rgba(0,0,0,.05)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<b>Busqueda</b>: "{searchQuery}"
				</div>
			)}
			{(loading || loadError) ? (
				<Header 
					loading={loading} 
					text={t(loading ? 'event_list.loading' : 'common.error')} 
					subtext={loadError || null}
					style={{ marginTop: 50, marginBottom: 50 }}
				/>
			) : data ? (
				<div className="fr striped selectable items">
					{data.map(a=>(
						<EventItem key={`EVTL-${a.event_id}`} event={a} creation={(!params?.popular && !params?.search) ? {
							first_date: a.date,
							date_created: (a as any).date_created,
							dates: (a as any).dates
						} : null} />
					))}
				</div>
			) : null}
		</Groupper>
	</div>
}

export default EventList;